import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loader',
    imports: [NgIf, MatProgressSpinnerModule],
    standalone:true,
    template: ` <div class="loading-container">
    <ng-content />
    <div *ngIf="loading" [class]="className">
      <div class="blocker-inner">
        <mat-spinner class="mat-spinner" [diameter]="diameter"> </mat-spinner>
      </div>
    </div>
  </div>`,
    styles: [
        `
@use "../../../../assets/scss/variables" as *;

      .loading-container {
      }
      .blocker {
        backdrop-filter: blur(10px);
        height: 100vh;
        width: 100%;
        z-index: 9;
        top: 0;
        left: 0;
        position: fixed;

        
      .blocker-inner {
        .mat-spinner {
          position: absolute;
          top: 50%;
          left: 50%;
          -moz-transform: translateX(-50%) translateY(-50%);
          -webkit-transform: translateX(-50%) translateY(-50%);
          transform: translateX(-50%) translateY(-50%);
        }
      }
      }

      .btn-mode{
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
      ::ng-deep {
        & .mat-mdc-progress-spinner {
          & .mdc-circular-progress__determinate-circle,
          & .mdc-circular-progress__indeterminate-circle-graphic {
            stroke: $primary!important;
          }
        }
      }
    `,
    ]
})
export class LoaderComponent {
  @Input() loading = false;
  @Input() diameter = '36';
  @Input() className = 'blocker'
}
